import * as React from 'react';
import { Tabs, Col, Row, Button, Modal, Alert } from 'antd';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import autobind from 'autobind-decorator';

const TabPane = Tabs.TabPane;

import { HeaderView } from 'src/app/shared/header.view';
import { ContactPartController } from 'src/app/crm/contacts/parts/contact-part.controller';
import { TextView } from 'src/core/ui/text.view';
import { DateView } from 'src/core/ui/date.view';
import { CardController } from 'src/app/shared/card.controller';
import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';
import { FormatService } from 'src/core/services/format.service';

interface ClientGDPRFormViewProps extends ComponentViewProps<ClientGDPRItem> {
	title: string,
	contextService: any;
	quoteDataService: DataSet<QuoteGDPRItem>;
	quotePaxDataService: DataSet<QuotePaxGDPRItem>;
	formatService: FormatService;
	anonymitation: () => Promise<void>;
	cancel: () => void;
	downloadClientJson: (ev: any) => void;
}

@observer
export class ClientGDPRFormView extends React.Component<ClientGDPRFormViewProps, {}> {
	@observable
	showAnomizarDialog: boolean;

	protected expandedRowRender = (item: QuoteGDPRItem) => {
		let paxColumns: Column[] = [
			{
				key: 'Salutation',
				dataIndex: 'salutation',
				render: (text: any, record: QuotePaxGDPRItem, index: number) => {
					return <span>{record.dynamicProperties['salutation']}</span>;
				},
				title: 'Salutation'
			},
			{
				key: 'ForeName',
				dataIndex: 'foreName',
				render: (text: any, record: QuotePaxGDPRItem, index: number) => {
					return <span>{record.dynamicProperties['foreName']}</span>;
				},
				title: 'Forename'
			},
			{
				key: 'MiddleName',
				dataIndex: 'middleName',
				render: (text: any, record: QuotePaxGDPRItem, index: number) => {
					return <span>{record.dynamicProperties['middleName']}</span>;
				},
				title: 'Middle Name'
			},
			{
				key: 'SurName',
				dataIndex: 'surName',
				render: (text: any, record: QuotePaxGDPRItem, index: number) => {
					return <span>{record.dynamicProperties['surName']}</span>;
				},
				title: 'SurName'
			},
			{
				key: 'nationality',
				dataIndex: 'dynamicProperties.nationality',
				title: 'Nationality'
			},
			{
				key: 'BirthDate',
				dataIndex: 'birthDate',
				render: (text: any, record: QuotePaxGDPRItem, index: number) => {
					return <span>{this.props.formatService.toString('short-date', record.dynamicProperties['birthDate'])}</span>;
				},
				title: 'BirthDate'
			},
			{
				key: 'Gender',
				dataIndex: 'Gender',
				render: (text: any, record: QuotePaxGDPRItem, index: number) => {
					return <span>{record.dynamicProperties['gender']}</span>;
				},
				title: 'Gender'
			}

		];
		return (
			<DataTableView
				columns={paxColumns}
				mode="display"
				clientFilter={(record) => this.getParentItems(record, item.id)}
				setBusy={this.props.setBusy}
				model={this.props.quotePaxDataService}
				rowKey="id"
				selection={false}
				hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hideModifyButtons}

			/>
		);
	}

	private getParentItems = (e: QuotePaxGDPRItem, quoteId: number) => {
		return e.quoteId == quoteId;
	}

	renderQuotes() {
		let columns: Column[] = [
			{
				key: 'quoteNumber',
				dataIndex: 'quoteNumber',
				title: 'Quote Number'

			},
			{
				key: 'dates',
				title: 'Date',
				children: [
					{
						key: 'dateFrom',
						dataIndex: 'dateFrom',
						title: 'From',
						render: (text, record: QuoteGDPRItem, index) => {
							return this.props.formatService.toString('small-date-time', text, "utc");
						}
					},
					{
						key: 'dateTo',
						dataIndex: 'dateTo',
						title: 'To',
						render: (text, record: QuoteGDPRItem, index) => {

							return this.props.formatService.toString('small-date-time', text, "utc");
						}
					}
				]
			},
			{
				key: 'statusText',
				dataIndex: 'statusText',
				title: 'Status',
			},
			{
				key: 'agentName',
				dataIndex: 'agentName',
				title: 'Agent',
			},
			{
				key: 'travelRegionCode',
				dataIndex: 'travelRegionCode',
				title: 'Destiny',
			},
		];
		return <DataTableView
			rowKey={(record) => record.id}
			expandedRowRender={this.expandedRowRender}
			columns={columns}
			mode="display"
			selection={false}
			setBusy={this.props.setBusy}
			model={this.props.quoteDataService}
			hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hideModifyButtons}
		/>
	}

	@autobind
	private closeModal(ev?: React.MouseEvent<HTMLButtonElement>) {

		this.showAnomizarDialog = false;
	}

	@autobind
	async aceptModal(ev?: React.MouseEvent<HTMLButtonElement>) {
		if (ev != null) {
			ev.preventDefault();
		}
		this.props.anonymitation();
		this.closeModal(ev);
	}

	render() {
		if (this.props.model == null) {
			return null;
		}
		let model: PersonItem = this.props.model.dynamicProperties.person;
		return (
			<div className="window window-normal">
				<Modal
					style={{ top: 20 }}
					width='80%'
					visible={this.showAnomizarDialog}
					onCancel={this.closeModal}
					title="Delete Client Information Confirmation"
					maskClosable={false}
					footer={[
						<Button
							key="confirm"
							type="primary"
							onClick={this.aceptModal}>
							Yes
						</Button>,
						<Button
							key="confirm"
							onClick={this.closeModal}>
							No
						</Button>
					]}>
					{
						<Alert
							message="Are you sure you want to delete the client's data?"
							description="This feature allows any customer to anonymize personal data stored by the app, including reservations' info and documents. This operation cannot be undone after."
							type="warning"
							showIcon
						/>
					}
				</Modal>

				<Row>
					<Col xs={24} lg={{ offset: 3, span: 18 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode="display"
									onModeChanged={null}
									save={null}
									cancel={this.props.cancel}
									hideModifyButtons={true}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						<div className="card p-3">
							<Row>
								<Col xs={24}>
									<Tabs defaultActiveKey="General information">
										<TabPane tab={<span>General information</span>} key="General information">
											<Row gutter={16}>
												<Col xs={24} lg={8}>
													<TextView
														label="First name"
														mode="display"
														value={model.firstName}
													/>
												</Col>
												<Col xs={24} lg={8}>
													<TextView
														label="Middle name"
														mode="display"
														value={model.middleName}
													/>
												</Col>
												<Col xs={24} lg={8}>
													<TextView
														label="Last name"
														mode="display"
														value={model.lastName}
													/>
												</Col>
											</Row>
											<Row gutter={16}>
												<Col xs={24} lg={8}>
													<DateView
														label="Birthdate"
														mode="display"
														format='date'
														value={model.birthDate}
													/>
												</Col>
												<Col xs={24} lg={8}>
													<TextView label='Email'
														value={this.props.model.dynamicProperties.email} mode="display"
													/>
												</Col>

											</Row>

										</TabPane>
										<TabPane tab={<span>Contact information</span>} key="Contact information">
											<CardController
												title="Addresses"
												icon="contacts"
												className="card-borderless"
												mode="display">
												<ContactPartController
													selection={false}
													model={this.props.model.dynamicProperties.contacts}
													parentModel={this.props.model}
													mode="display"
													setBusy={this.props.setBusy}
													contextService={this.props.contextService}
													hideModificationButton={true}
												/>
											</CardController>

										</TabPane>
										
										<TabPane tab={<span>Quotes</span>} key="Quotes">
											{this.renderQuotes()}
										</TabPane>
									</Tabs>

								</Col>
							</Row>
							<Row>
								<Col xs={24} lg={8}>

									<Button
										icon='delete'
										onClick={() => this.showAnomizarDialog = true}
									>
										Anonymize
								</Button>

								</Col>

								<Col xs={24} lg={8}>
									<Button
										icon='download'
										onClick={this.props.downloadClientJson}
									>
										Download
									</Button>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>

			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/gdpr/clients/form/client-gdpr-form.view.tsx